/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Start_Time_Only_AriaInputs */



/**
* | output |
* | --- |
* | "Apply compensation to start time only" |
*
* @param {Timing_Sync_Start_Time_Only_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_start_time_only_aria = /** @type {((inputs?: Timing_Sync_Start_Time_Only_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Start_Time_Only_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer la compensation uniquement a l'heure de debut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Vergütung gilt nur für den Arbeitsbeginn.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applicare la compensazione solo all'orario di inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Компенсация применяется только к времени начала работы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar compensación solo a la hora de inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("补偿仅适用于开始时间。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始時間のみに補正を適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मुआवजा केवल प्रारंभ समय पर लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar a compensação apenas ao tempo de início.")
	return /** @type {LocalizedString} */ ("Apply compensation to start time only")
});